import React, { useState } from 'react';
import { SessionReview } from './SessionReview';
import { SpecialistReview } from './SpecialistReview';
import { CardModal, useDomRef } from '@mindly/ui-components';

export type ReviewSubscriptionSessionFeatureProps = {
  specialistName: string;
  specialistAvatar: string;
  isOpen: boolean;
  specialistReviewNeeded?: boolean;
  sessionReviewProps?: React.ComponentProps<typeof SessionReview> & {
    onModalAppeared?: () => void;
  };
  specialistReviewProps: React.ComponentProps<typeof SpecialistReview> & {
    onModalAppeared?: () => void;
  };
  onClose: () => void;
  onCloseClick: (step: 'session' | 'specialist') => void;
  initialStep?: 'session' | 'specialist';
};

const ReviewSubscriptionSessionFeatureTempo: React.FC<ReviewSubscriptionSessionFeatureProps> = ({
  specialistName,
  specialistAvatar,
  isOpen,
  specialistReviewNeeded,
  sessionReviewProps,
  specialistReviewProps,
  onClose,
  onCloseClick,
  initialStep = 'session',
}) => {
  const modalRef = useDomRef<HTMLIonModalElement>(null);
  const [step, setStep] = useState<'session' | 'specialist'>(initialStep);

  const handleSessionSubmit = async (data: any) => {
    if (sessionReviewProps?.onSubmit) {
      await sessionReviewProps.onSubmit(data);
    }
    if (specialistReviewNeeded) {
      setStep('specialist');
    } else {
      modalRef.current?.dismiss();
    }
  };

  const handleSpecialistSubmit = async (data: any) => {
    if (specialistReviewProps.onSubmit) {
      await specialistReviewProps.onSubmit(data);
    }
    modalRef.current?.dismiss();
  };

  return (
    <CardModal
      ref={modalRef}
      isOpen={isOpen}
      isShowCloseButton={true}
      isShowHandle={false}
      onDidDismiss={onClose}
      onCloseClick={() => onCloseClick?.(step)}
    >
      {step === 'session' && (
        <SessionReview
          {...sessionReviewProps}
          specialistName={specialistName}
          specialistReviewNeeded={specialistReviewNeeded}
          onSubmit={handleSessionSubmit}
        />
      )}
      {step === 'specialist' && (
        <SpecialistReview
          {...specialistReviewProps}
          specialistName={specialistName}
          specialistAvatar={specialistAvatar}
          specialistReviewNeeded={specialistReviewNeeded}
          onSubmit={handleSpecialistSubmit}
        />
      )}
    </CardModal>
  );
};

export default ReviewSubscriptionSessionFeatureTempo;
